import React from 'react';
import BasePage from '@/components/BasePage';
import BaseLayout from '@/components/layouts/BaseLayout';
import { Row, Col, Container } from 'reactstrap';
// Translation Higher Order Component
import { translate } from 'react-switch-lang';

const CoronaTest = ({ t }) => {
	return (
		<React.Fragment>
			<BaseLayout
				className="cover"
				title="Coronavirus Test"
				description={`${t('coronatest.text4')} ${t('coronatest.text5')}`}
				keywords={`COVID-19 ${t('SEO.keywords_common')} ${t('SEO.keywords_coronatest')}`}
				canonical="/covid-test"
			>
				{/* Base Page - Shared component with Container */}
				<BasePage id="coronatest-page" className="coronatest-page">
					<Container>
						<article>
							<h2 className="page_text font-weight-bold">CORONAVIRUS TEST</h2>
							<p className="page_subtext text-uppercase">{t('coronatest.title')}</p>
							<hr className="vaccination-page_hr" />
							<p className="font-weight-bold">{t('coronatest.title2')}</p>
							<p>{t('coronatest.text4')}</p>
							<p className="page_subtext text-uppercase">{t('coronatest.title3')}</p>
							<p>{t('coronatest.text5')}</p>

							<Row>
								<Col md="6" className="consultation-page_text-container covid">
									<p className="page_subtext text-uppercase">{t('coronatest.answer')}</p>
									<p>{t('coronatest.text6')}</p>
									<p>{t('coronatest.text7')}</p>
									<p className="page_subtext text-uppercase">{t('coronatest.price')}</p>
									<p>
										{t('coronatest.text8')} 905 DKK {t('coronatest.text20')}
									</p>
									<p>
										{t('coronatest.text9')} 1180 DKK {t('coronatest.text20')}
									</p>
									<p>
										{t('coronatest.text10')} 1180 DKK {t('coronatest.text20')}
									</p>
								</Col>
								<Col md="6" className="consultation-page_img-container">
									<img
										width="520"
										height="347"
										className="shadowed-img img-fluid px-xs-5"
										src="/images/covid-test.webp"
										alt="Covid-19 Test"
									/>
								</Col>
							</Row>
							<p>
								<em>{t('coronatest.text11')}</em>
							</p>
							<p>
								<em>{t('coronatest.text12')}</em>
							</p>

							<Row className="justify-content-center pb-3">
								<a
									rel="external nofollow noopener"
									target="_blank"
									className="booking_button clickable open_booking-iframe-navbutton text-uppercase"
								>
									Coronavirus Test
								</a>
							</Row>
						</article>
					</Container>
				</BasePage>
			</BaseLayout>
		</React.Fragment>
	);
};

export default translate(CoronaTest);
